import React from "react";
import Loadable from "react-loadable";
import { Route } from "react-router-dom";

import { ROUTES } from "@config/app.routing";
import { LOADABLE_COMPONENT_DELAY } from "@config/consts";

import { FadeInContainer } from "@ui/Atoms";

import { useFeatureToggle } from "@hooks/useFeatureToggle";

import { NotFound } from "@app/pages/NotFound";

import { PageSkeleton } from "./UrssafRegistration.skeletons";

const LoadableRegistrationForm = Loadable({
  loader: () => import("./steps/UrssafRegistrationForm/UrssafRegistrationForm"),
  render(loaded: any, props: any): JSX.Element {
    const Component = loaded.UrssafRegistrationForm;
    return <Component {...props} />;
  },
  loading: PageSkeleton,
  delay: LOADABLE_COMPONENT_DELAY,
});

const UrssafRegistration = (): React.ReactElement => {
  const urssafEnabled = useFeatureToggle("pwa_urssaf");

  return (
    <React.Fragment>
      {urssafEnabled && (
        <Route
          exact
          path={ROUTES.URSSAF_REGISTRATION}
          render={props => (
            <FadeInContainer>
              <LoadableRegistrationForm {...props} />
            </FadeInContainer>
          )}
        />
      )}
      {!urssafEnabled && <NotFound />}
    </React.Fragment>
  );
};

export { UrssafRegistration };
